import { useEffect, useState } from 'react'
import { useNavigate } from 'react-router-dom'
// import Image from '../../../Assets'
// import MyImage from 'Components/MyImage'
// import LockPop from './Lockpop'
import { useView } from 'Context/viewContext'
import { useQuery } from '@tanstack/react-query'
import { useAuth } from 'Context/authContext'
import { useEnroll } from 'Context/enrollContext'
import constants from '../../constants';
import axios from 'axios'
import { Book, BookOpen, ChevronLeft, File, LogOut, MonitorStop, Presentation, Vote } from 'lucide-react'
import TruncatedText from 'Components/Truncate'
import { WhatsappIcon } from 'react-share'

interface menuArr {
  title?: string
  id?: string
  status?: string
  icon?: string
  subMenu?: Array<menuArr>; // Nested submenu items
}
interface Sidebar {
  menuArr: Array<menuArr>
  currentMenu: string | undefined
  setCurrentMenu: any
  isMenuActive: boolean,
  setIsMenuActive: any
  setIsPopupOpen:any
}

export default function Sidebar_Program({ menuArr, currentMenu, setCurrentMenu, isMenuActive, setIsMenuActive,setIsPopupOpen }: Sidebar) {
  const navigate = useNavigate()
  // const [display, setDisplay] = useState<boolean>(false)
  const { isMobile } = useView()
  const { getToken } = useAuth()
  const { enroll, updateEnroll } = useEnroll()
  const {logout} = useAuth()
  const [quiz, setQuiz] = useState<any>(0);
  
  async function fetchData() {
    if (menuArr?.find(menuItem => menuItem.id === 'quiz')?.id !== 'quiz')
      return 0

    const token = await getToken();
    try {
      if (!token) throw new Error('Token is missing');
      const res = await axios.get(`${constants.DOMAIN}/api/v1/enroll/quiz/status/${enroll._id}`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });
      let count: number = 0
      if (JSON.stringify(res.data.data.ongoing) !== JSON.stringify({})) {
        count += 1
      }
      // console.log(count);
      if (res.data.data.pending && res.data.data.pending.length > 0) {
        count += res.data.data.pending.length
      }
      // console.log(count);
      if (count > 0) {
        setQuiz(count)
      }
      // console.log(res)
      return res.data.data;
    } catch (error) {
      console.error('Error fetching data:', error);
      throw error;
    }
  }

  const { refetch } = useQuery({
    queryKey: ['quizUSer'],
    queryFn: fetchData,
    refetchOnMount: false,
    refetchOnWindowFocus: false,
    refetchInterval: false,
  });

  useEffect(() => {
    refetch()
  }, []);

  const menuArrayFooter: menuArr[] = [
    // { title: 'Back to Programs', id: 'back', icon: "BackIcon", },
    { title: 'Log Out', id: 'logout', icon: "LogoutIcon", }
  ]

  return (
    // <div className={` bg-[#21132c] absolute transition-all z-[9999] duration-500 ease-in-out md:relative tailwingSidebar phone:h-full pt-4  phone:pt-6 ${isMenuActive? 'w-4/5 md:w-72' : 'w-0'} ' id="sidebar-desktop`}>
    <div className={`flex overflow-hidden flex-col justify-between border-r-1 border-[#e2e2e2] bg-white h-[100dvh] top-0 transition-all duration-500 ease-in-out z-[9990] ${isMobile ? isMenuActive ? 'w-4/5 md:w-72 absolute' : 'w-0 absolute' : 'w-72'}`} id="sidebar-desktop">
      {/* <div className={`absolute hidden md:block top-1/2 right-[-35px] z-50 ${isMenuActive?"":"transform rotate-540"} `} onClick={()=>setIsMenuActive(!isMenuActive)}><MyImage src={Image.Sidebar_Toogle} className={` ${isMenuActive?"":"transform transition-all rotate-180"} `} loadOnPageLoad={true} /> </div> */}
      {/* <LockPop display={display} setDisplay={setDisplay} /> */}
      {isMenuActive && (
        <div className="md:hidden absolute right-0 p-2">
          <span className='cursor-pointer'>
            <img onClick={() => {
              setIsMenuActive(!isMenuActive)
              // setIsSubMenuOpen(false)

            }} width="25" height="25" className='block md:hidden' src={`https://img.icons8.com/ios-filled/64/multiply.png`} alt="menu--v6" />
          </span>
        </div>
      )}
      <div>

        <div className="text-gray-900 bg-gray-100">
          <button    onClick={() => navigate(`/v1/user/dashboard/course`)} className='font-semibold text-sm phone:text-base w-max p-4 py-[20px] flex gap-2 items-center' >
            <ChevronLeft
           
              strokeWidth={1.5} className={`w-6 h-6 md:w-7 md:h-7 p-1 hover:bg-gray-200`} />
            <span className="item">Back to dashboard</span>
          </button>
        </div>
      <ul className='list-none overflow-hidden w-max px-4'>
        {/* {!isMobile && (
        <div className="md:w-48 mb-2  h-20  p-3">
          <span className='cursor-pointer'>
            <img onClick={() => navigate('/')} id="logoimgHeader" className='w-auto h-full md:block overflow-hidden' src="https://i.ibb.co/FxHVzmm/Logo.png" alt={'logo'} />
          </span>
        </div>
        )} */}
        {menuArr?.map((element, index) => {
          return (
            // <li className={`${element.id === currentMenu ? "bg-[#471770] rounded-sm sidebar_active" :element.id ==='title'?'border-b-2 border-solid border-brand ':element.id==='dashboard'?` ${isMenuActive?"":"hidden"} border-t-2 w-full  border-solid border-brand absolute bottom-2 md:bottom-[5px]`:""}`} key={index}>
            <li className={`${element.id === currentMenu ? "text-gray-900 bg-gray-100 rounded-lg" : "text-gray-500"}`} key={index}>
              <button className='font-semibold text-sm phone:text-base w-max mb-2 mt-2  p-4 py-[9px] flex gap-2 items-center' onClick={() => {
                if (isMobile) setIsMenuActive(false)
                // if(element.id === 'title' || element.status ==='LOCKED'){
                //   if(element.id!=='title')
                //   setDisplay(true)
                //   return
                // }
                if (element.id === 'title') {
                  return
                }
                if (element.id === 'doubt') {
                  setIsPopupOpen(true)
                  return
                }
                if (element.id === 'what') {
                  window.open(enroll.groupLink,'_blank')
                  return
                }
                else if (element.id === 'dashboard')
                  navigate(`/v1/user/dashboard/course`)
                else
                  navigate(`/v1/program/dashboard/${element.id}`)
              }}>
                {element.icon === "LmsIcon" && <MonitorStop strokeWidth={1.5} className={`w-6 h-6 md:w-7 md:h-7 p-1 hover:bg-gray-200  ${element.id === currentMenu && "text-brand"}`} />}
                {element.icon === "ResumeIcon" && <File strokeWidth={1.5} className={`w-6 h-6 md:w-7 md:h-7 p-1 hover:bg-gray-200   ${element.id === currentMenu && "text-brand"}`} />}
                {element.icon === "ChallengeIcon" && <BookOpen strokeWidth={1.5} className={`w-6 h-6 md:w-7 md:h-7 p-1 hover:bg-gray-200   ${element.id === currentMenu && "text-brand"}`} />}
                {element.icon === "InternshipIcon" && <Vote strokeWidth={1.5} className={`w-6 h-6 md:w-7 md:h-7 p-1 hover:bg-gray-200   ${element.id === currentMenu && "text-brand"}`} />}
                {element.icon === "AiInterview" && <Presentation strokeWidth={1.5} className={`w-6 h-6 md:w-7 md:h-7 p-1 hover:bg-gray-200   ${element.id === currentMenu && "text-brand"}`} />}
                {element.icon === "NotesIcon" && <Book strokeWidth={1.5} className={`w-6 h-6 md:w-7 md:h-7 p-1 hover:bg-gray-200   ${element.id === currentMenu && "text-brand"}`} />}
                {element.icon === "DoubtIcon" && <Book strokeWidth={1.5} className={`w-6 h-6 md:w-7 md:h-7 p-1 hover:bg-gray-200   ${element.id === currentMenu && "text-brand"}`} />}
                {element.icon === "what" && <WhatsappIcon strokeWidth={1.5} className={`w-6 h-6 md:w-7 md:h-7 p-1 hover:bg-gray-200 rounded-md  ${element.id === currentMenu && "text-brand"}`} />}

                <span className={`item  ${element.id === "title" ? "font-semibold text-lg" : "text-sm"}`} style={{ color: element.id === "title" ? "#971eff" : "" }}>
                  {element.id === "quiz"
                   ? 
                  <><TruncatedText maxLength={20} text={element.title || ""} />
                   {
                  quiz > 0 && <span className={`text-[12px] font-bold me-2 px-1.5 py-1 rounded-full  text-black ml-1 `}>{quiz > 1 ? quiz - 1 : quiz}+</span>}</>
                   :
                   <TruncatedText maxLength={20} text={element.title || ""} />}
                    {!element.icon && <div className="line-grade w-full h-1 mt-2"></div>}
                  </span>
                {/* {element.status!=='NONE'&&<span className='flex items-center w-[20%] justify-center'>{images[element.status||'LOCKED']}</span>} */}
              </button>
              
            </li>
          )
        })}
      </ul>
      </div>

      <ul className='list-none overflow-hidden p-4'>
        {menuArrayFooter.map((element, index) => {
          return (
            // <li className={`${element.id === currentMenu ? "bg-[#471770] rounded-sm sidebar_active text-white" : "text-black"}`} key={index}>
            <li className={`${element.id === "back" ? "text-black sidebar_active" : "text-red-500"}`} key={index}>
              <button className=' font-semibold text-sm phone:text-sm w-max mb-2 mt-2  p-4 py-[9px] flex gap-2 items-center' onClick={() => {
                // if (isMobile) setIsMenuActive(false)
                // if (element.id == "back") navigate(`/v1/user/dashboard/course`)
                // if (element && element?.subMenu && element.subMenu.length > 0)
                //   setIsSideBarOpen(element.subMenu)
                if(element.id == "logout") {
                  localStorage.removeItem('user')
                  localStorage.removeItem('cohort')
                  localStorage.clear()
                  sessionStorage.clear()
                  updateEnroll({_id:''})
                  logout()
              }
              }}>
                {element.icon === "LogoutIcon" && <LogOut strokeWidth={1.5} className={`w-6 h-6 md:w-7 md:h-7 p-1 hover:bg-gray-200  rounded-full ${element.id === currentMenu && "text-brand"}`} />}
                {/* {element.icon === "BackIcon" && <CircleArrowLeft strokeWidth={1.5} className={`w-6 h-6 md:w-7 md:h-7 p-1 hover:bg-gray-200  rounded-full ${element.id === currentMenu && "text-brand"}`} />} */}
                {element.icon === "BackIcon" && <ChevronLeft strokeWidth={1.5} className={`w-6 h-6 md:w-7 md:h-7 p-1 hover:bg-gray-200  rounded-full ${element.id === currentMenu && "text-brand"}`} />}
                <span className="item" style={{ color: element.id === "alpha" ? "" : "" }}>{element.title}</span>
                
              </button>

            </li>
          )
        })}
      </ul>
    </div>
  )
}


